var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboPicking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.21002 20.3801C4.57002 20.6101 3.05002 19.4701 2.82002 17.8301C2.59002 16.1901 3.73002 14.6701 5.37002 14.4401C7.01002 14.2101 8.53002 15.3501 8.76002 16.9901C8.99002 18.6301 7.85002 20.1501 6.21002 20.3801ZM5.65002 16.4201C5.10002 16.5001 4.72002 17.0001 4.80002 17.5501C4.88002 18.1001 5.38002 18.4801 5.93002 18.4001C6.48002 18.3201 6.86002 17.8201 6.78002 17.2701C6.70002 16.7201 6.20002 16.3401 5.65002 16.4201Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.06996 16.0302C8.95996 15.7302 9.14996 15.4102 9.46996 15.3602L18.87 14.0302C19.44 13.9502 19.97 14.3302 20.05 14.8702C20.13 15.4102 19.73 15.9302 19.15 16.0102L9.95996 17.3102C9.72996 17.3402 9.49996 17.2102 9.41996 16.9902L9.06996 16.0302Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.70002 13.2902L3.12002 2.20019L1.14002 2.48019C0.590023 2.55019 0.0900234 2.17019 0.0100234 1.63019C-0.0699766 1.09019 0.310023 0.570194 0.860023 0.500194L4.32002 0.000193516C4.59002 -0.0398065 4.85002 0.150193 4.89002 0.420193L6.70002 13.1902C6.74002 13.5002 6.50002 13.7702 6.18002 13.7602L5.16002 13.7102C4.92002 13.7002 4.72002 13.5202 4.69002 13.2802L4.70002 13.2902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.3001 13.3202L8.39007 14.5802C8.12007 14.6202 7.86007 14.4302 7.82007 14.1602L7.12007 9.2102C7.08007 8.9402 7.27007 8.6802 7.54007 8.6402L16.4501 7.3802C16.7201 7.3402 16.9801 7.5302 17.0201 7.8002L17.7201 12.7502C17.7601 13.0202 17.5701 13.2802 17.3001 13.3202ZM9.59007 12.3902L15.5301 11.5502L15.2501 9.5702L9.31007 10.4102L9.59007 12.3902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.34 6.54017L7.40996 7.52017C7.13996 7.56017 6.87996 7.37017 6.83996 7.10017L6.13996 2.15017C6.09996 1.88017 6.28996 1.62017 6.55996 1.58017L13.49 0.600169C13.76 0.560169 14.02 0.750169 14.06 1.02017L14.76 5.97017C14.8 6.24017 14.61 6.50017 14.34 6.54017ZM8.60996 5.33017L12.57 4.77017L12.29 2.79017L8.32996 3.35017L8.60996 5.33017Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboPicking);
export default __webpack_public_path__ + "static/media/FBOPicking.760db0259604b177083356cabbc50281.svg";
export { ForwardRef as ReactComponent };